import { createAsyncThunk } from "@reduxjs/toolkit";
import api, { TOKEN } from "../../api/axiosInstance";

export const register = createAsyncThunk(
  "auth/register",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { first_name, last_name, birthday, email, phone_number, password, street_address, city, state, country } = formInfo;
      const res = await api.post("user/register", {
        first_name,
        last_name,
        birthday,
        email,
        phone_number,
        password,
        street_address,
        city,
        state,
        country,
      });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const authenticate = createAsyncThunk(
  "auth/authenticate",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { email, password } = formInfo;
      const res = await api.post("user/login", { email, password });
      if (res.status === 200) {
        await window.localStorage.setItem(TOKEN, res.data.token);
      }
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const confirm2FA = createAsyncThunk(
  "auth/confirm2FA",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { email, code } = formInfo;
      const res = await api.post("user/verify2fa", { email, code });
      if (res.status === 200) {
        await window.localStorage.setItem(TOKEN, res.data.token);
      }
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const googleSSO = createAsyncThunk(
  "auth/googleSSO",
  async ({ credential }, { rejectWithValue }) => {
    try {
      const res = await api.post("user/sso/google", { credential });
      if (res.status === 200) {
        await window.localStorage.setItem(TOKEN, res.data.token);
      }
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const generateResetCode = createAsyncThunk(
  "auth/generateResetCode",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { email } = formInfo;
      const res = await api.post("user/generateResetCode", { email });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const confirmResetCode = createAsyncThunk(
  "auth/confirmResetCode",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { email, code } = formInfo;
      const res = await api.post("user/confirmResetCode", { email, code });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { code, email, new_pass_1, new_pass_2 } = formInfo;
      const res = await api.post("user/resetPassword", {
        code,
        email,
        new_pass_1,
        new_pass_2,
      });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { curr_pass, new_pass_1, new_pass_2 } = formInfo;
      const res = await api.post("user/changePassword", {
        curr_pass,
        new_pass_1,
        new_pass_2,
      });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.post("user/logout", {});
      await window.localStorage.removeItem(TOKEN);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const expiredLogout = createAsyncThunk("auth/expiredLogout", async () => {
  await window.localStorage.removeItem(TOKEN);
});

export const deleteUser = createAsyncThunk(
  "auth/deleteUser",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.delete("user");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);
